<div *ngIf="assetImage" class="cursor-pointer display-flex" id="{{asset._id}}">
  <sh-card class="opacity-value" [routerLink]="routePath" card-height='300px' image="{{ assetImage }}"
    [ngStyle]="{'pointer-events': checkVisibility() ? 'all' : 'none','opacity': checkVisibility() ? 1 : 0.5}">
    <div>
      <sh-text class="asset-name">{{asset.assetName}}</sh-text>
    </div>

    <div class="comment-fav-icon-div">
      <sh-grid>
        <div columns="5"></div>
        <div class="tooltip comments-div" columns="1">
          <sh-icon class="tooltip font-size-18" color="secondary" icon="chapter">
          </sh-icon>
          <sh-text class="tooltiptext">{{asset.noOfComments}}</sh-text>
        </div>

        <div class="tooltip raters-div" columns="1">
          <sh-icon class="tooltip font-size-18" color="secondary" icon="favorite"></sh-icon>
          <sh-text class="tooltiptext">{{raters}}</sh-text>
        </div>
        <div columns="5"></div>
      </sh-grid>
    </div>

    <div>
      <span class="stars stars-margin">
        <span *ngIf="asset.avgRating" [ngStyle]="{ 'width': getStars() }"></span>
      </span>
    </div>

  </sh-card>
</div>
<sh-tooltip *ngIf="!checkVisibility()" label="Private Asset" target="{{asset._id}}" placement="top" variation="short">
</sh-tooltip>